enum Handlers {
    Smart = 1,
    Protocol = 2,
    Json = 3,
    MBus = 4,
    ModBus = 5,
    Svtu11Rp = 6,
}

export default Handlers;
